import { render, staticRenderFns } from "./EstadoReclamaciones.vue?vue&type=template&id=25cb8df6&"
import script from "./EstadoReclamaciones.vue?vue&type=script&lang=js&"
export * from "./EstadoReclamaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports